// please use this pattern for all mixpanel events:
// "FEATURE__DETAILS_ABOUT_THE_EVENT" notice the double underscore after the feature name

// event names (the string value) should be easy to understand and describe why they matter in the users flow regarding the feature they are using
// try to describe what is happening in a human readable way
// use words like "navigated", "contacted", "sent", "closed" etc instead of just "clicked"

// event constant names do not need to be as descriptive, they are only dev facing

const NAV__ITEM_SELECTED = "Navigation - Navigated to Nav Item";

export { NAV__ITEM_SELECTED };
